import {  DS_IFRAME_EVENTS } from '@trip-ux/constants';
import { useCallback } from 'react';

export const getCardType = cardPrefix => {
  let type = '';
  const firstDigit = cardPrefix.charAt(0);
  if (firstDigit === '4') {
    type = 'visa';
  } else if (firstDigit === '5') {
    type = 'mastercard';
  } else if (firstDigit === '3') {
    type = 'american-express';
  }
  return type;
};

const generateMessage = (event, fieldType, fieldIndex, payload) => {
  const msg = {
    purpose: 'protection',
    source: 'parent',
    type: 'style', // DS only checks that type is not undefined
    event, // DS does not check the event
    target: fieldType,
    index: fieldIndex,
    additional: {
      ...payload
    }
  };
  return JSON.stringify(msg);
};

export const useIframeEventHandler = (
  iframeUrl,
  inputStylesInitial,
  inputStylesValid,
  inputStylesInvalid,
  supplementalStyles
) => {
  const handleIframeEvent = useCallback(
    message => {
      if (message.event === DS_IFRAME_EVENTS.ON_READY) {
        if (!inputStylesInitial && !inputStylesValid && !inputStylesInvalid) {
          return;
        }

        const payload = {
          style: {
            ...(inputStylesInitial ? { field: inputStylesInitial } : {}),
            ...(inputStylesValid ? { onvalid: inputStylesValid } : {}),
            ...(inputStylesInvalid ? { oninvalid: inputStylesInvalid } : {}),
            ...(supplementalStyles ? { fieldAttributes: supplementalStyles } : {})
          }
        };

        const msg = generateMessage('onready', message.target, message.index, payload);
        message.iframe.contentWindow.postMessage(msg, iframeUrl);
      }
    },
    [inputStylesInitial, inputStylesValid, inputStylesInvalid, supplementalStyles]
  );

  return [handleIframeEvent];
};
